<template>
	<div :class="classes">
		<FontAwesomeIcon
			:icon="['fas', 'list']"
		/>
	</div>
</template>

<script>

export default {
	name: "MobileMenuIcon",
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"mobile-menu-icon": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.mobile-menu-icon {
	display: inline-flex;
	cursor: pointer;

	svg {
		color: $mobile-menu-icon-color;
		font-size: 1.5rem;
	}
}
</style>
